import type { QuizBuilderOptionsSchema } from '@repo/schemas/quiz/quizBuilder';

import { useFormContext, useWatch } from 'react-hook-form';

import { Button } from '@/components/ui/button';
import { DateTimeRangePicker } from '@/components/ui/date-time-picker';
import { FormControl, FormField, FormItem, FormMessage } from '@/components/ui/form';

export default function QuizBuilderDateTimeSelector() {
  const { control, setValue } = useFormContext<QuizBuilderOptionsSchema>();

  const available = useWatch({ name: 'available', control });
  const deadline = useWatch({ name: 'deadline', control });

  return (
    <div className="w-full">
      <FormField
        name="available"
        render={({ field }) => (
          <FormItem className="w-full">
            <div className={'flex justify-end'}>
              <Button
                size={'sm'}
                variant={'ghost'}
                type={'button'}
                onClick={() => {
                  setValue('available', null, { shouldValidate: true });
                  setValue('deadline', null, { shouldValidate: true });
                }}
              >
                Wyczyść
              </Button>
            </div>
            <FormControl>
              <DateTimeRangePicker
                from={available}
                to={deadline}
                ref={field.ref}
                name={field.name}
                disabled={field.disabled}
                onBlur={field.onBlur}
                onFromChange={(value) => {
                  setValue('available', value, { shouldValidate: true });
                }}
                onToChange={(value) => {
                  setValue('deadline', value, { shouldValidate: true });
                }}
                className="w-full"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField name="deadline" render={() => <FormMessage />} />
    </div>
  );
}
